<template>
  <div class="swipetype">
    <div
      v-for="(item, index) in typeList"
      :key="index"
      :class="current_type === index ? 'swipetypeActive' : 'swipetype_item'"
      @click="SwiperChange(index)"
    >
      <img
      class="img"
        v-if="current_type == index"
        src="../../static/images/home/tinified/swiperselect.png"
       
        alt=""
        style="margin-right: 10px"
      />
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "swiperchange",
  props: {
    typeList: [],
    current_type: 0,
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
  methods: {
    SwiperChange(index) {
      this.$emit("SwiperChange", index);
    },
  },
};
</script>
<style scoped lang="scss">
.swipetype {
  width: 81%;
  display: flex;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: center;
  .img{
    width:7px;
    height: 12px;
  }
}

.swipetype_item {
  color: #777777;
  cursor: pointer;
  font-size: 16px;
  margin: 5px 30px;
}

.swipetypeActive {
  color: #2525cc;
  cursor: pointer;
  font-size: 16px;
  margin: 5px 30px;
}

// .type_item:hover {
//   background: #c5c5c5;
//   border-color: #c5c5c5;
//   color: #202020;
// }
</style>



// WEBPACK FOOTER //
// src/components/swiperchange.vue